import React from 'react';
import CasesDashboard from 'containers/pages/cases/CasesDashboard';

export default function Cases() {
  return <CasesDashboard />;
}
